const appendLinkElement = (relValue: string, hrefValue: string) => {
    const head = document.querySelector("head");
    const link = document.createElement("link");
    link.setAttribute("rel", relValue);
    link.setAttribute("href", hrefValue);
    head?.appendChild(link);
};

const getLinkElement = (relValue: string, hrefValue: string) => {
    const linkElement = getlinkElementList().find(
        l => l.getAttribute("rel") === relValue && l.getAttribute("href") === hrefValue,
    );
    return linkElement;
};

const getlinkElementList = () => {
    return Array.from(document.getElementsByTagName("link"));
};

const removeLinkElement = (relValue: string, hrefValue: string) => {
    const head = document.querySelector("head");
    const link = getLinkElement(relValue, hrefValue);
    if (link) {
        head?.removeChild(link);
    }
};

const hasLinksWithRelPrevNext = (prev: string, next: string) => {
    const relPrevrelNext = { hasPrev: false, hasNext: false };
    const linkElementList = getlinkElementList();
    relPrevrelNext.hasPrev = linkElementList.some(
        l => l.getAttribute("rel") === "prev" && l.getAttribute("href") === prev,
    );
    relPrevrelNext.hasNext = linkElementList.some(
        l => l.getAttribute("rel") === "next" && l.getAttribute("href") === next,
    );
    return relPrevrelNext;
};

export default getLinkElement;
export { appendLinkElement, getlinkElementList, hasLinksWithRelPrevNext, removeLinkElement };
